import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import pluralize from 'rebook/apps/utils/text/pluralize';
import BreadCrumbs from 'rebook/apps/base/components/BreadCrumbs';
import ContextPagination from 'rebook/apps/base/components/ContextPagination';
import AuthorList from 'rebook/apps/catalog/components/AuthorList';
import CatalogFilter from 'rebook/apps/catalog/components/Filters/CatalogFilter';
import { SORT_BY_NEW_POPULAR_AUTHORS } from 'rebook/apps/base/constants';
import * as AuthorListActions from 'rebook/apps/catalog/actions/AuthorListActions';

import styles from './style.scss';


class AuthorListView extends React.Component {
  static fetchInitialDataForServer(match, store) {
    return store.dispatch(AuthorListActions.fetchInitialData(match));
  }
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { match, location } = this.props;
    this.props.AuthorListActions.fetchInitialData(match, location);
  }

  componentWillUnmount() {
    this.props.AuthorListActions.resetData();
  }

  changePage(pageNumber) {
    this.props.AuthorListActions.fetchAuthorList({ pageNumber });
  }

  changeOrderBy(orderBy) {
    this.props.AuthorListActions.fetchAuthorList({ orderBy, pageNumber: 1 });
  }

  resetFilters() {
    this.props.AuthorListActions.fetchAudiobookList({ orderBy: 'book_count' });
  }

  getAuthorsCounterBlock(totalAuthorsCount) {
    const counterText = `${pluralize(totalAuthorsCount, 'автор', 'автора', 'авторов')}`;
    if (totalAuthorsCount === null) {
      return (
        <div className={styles.countEmpty} />
      );
    }

    return (
      <div className={styles.count}>
        <span>
          {totalAuthorsCount}&nbsp;{counterText}
        </span>
      </div>
    );
  }

  render() {
    const { authorList } =this.props;
    const { list, lastPageNumber, pageNumber, orderBy, totalAuthorsCount } = authorList;

    return (
      <div className="section">
        <BreadCrumbs links={[
          { text: 'Каталог', url: '/catalog/' },
          { text: 'Авторы', url: '' },
        ]} />
        <div className="sectionHeader">
          <h1>Все авторы</h1>
        </div>
        {this.getAuthorsCounterBlock(totalAuthorsCount)}
        <CatalogFilter
          orderBy={orderBy}
          orderByValues={SORT_BY_NEW_POPULAR_AUTHORS}
          isSubscriptionEnabled={false}
          isBookTypeEnabled={false}
          isResultEmpty={list && list.length === 0}
          onChangeOrder={(value) => this.changeOrderBy(value)}
          onResetFilter={()=> this.resetFilters()} />
        {(authorList && list) && (
          <AuthorList authors={list} orderBy={orderBy} />
        )}
        {(list === null) && (
          <AuthorList authors={[...Array(48)]} />
        )}
        {(lastPageNumber > 1 && list && list.length > 0) && (
          <ContextPagination
            extraClassName="jest-authors-page-list-pagination"
            onPageChange={(newPageNumber) => this.changePage(newPageNumber)}
            currentPage={pageNumber}
            lastPage={lastPageNumber} />
        )}
      </div>
    );
  }
};

const mapStateToProps = (state) => ({
  authorList: state.authorList,
});

const mapDispatchToProps = (dispatch) => ({
  AuthorListActions: bindActionCreators(AuthorListActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AuthorListView);
